<template>
  <div class="container">
    <div style="width: 100%">
      <div class="divimg">
        <img :src="dataItem.imgUrl">
        <p v-html="dataItem.content"></p>
        <!-- {{dataItem.content}} -->
      </div>
    </div>
  </div>
</template>

<script>
import dataSource from '@/data/detail'
export default {
  name: 'content',
  data () {
    return {
      dataSource,
      dataItem: {}
    }
  },
  created () {
    let id = this.$route.query.id
    this.dataItem = dataSource[id]
  }
}
</script>

<style scoped>
  .divimg {
    padding: 5px;
  }
  .divimg img {
    width: 50%;
    border: 0px;
    float: left;
  }
  @media (min-width: 220px) {
    .divimg {
      padding: 5px;
      line-height: 30px;
      margin-top: 30px;
    }
    .divimg img {
      width: 100%;
      border: 3px;
      float: left;
    }
  }
  @media (min-width: 1200px) {
    .divimg {
      padding: 5px;
      line-height: 30px;
      min-height: 600px;
      margin-top: 30px;
    }
    .divimg img {
      width: 100%;
      border: 3px;
      float: left;
      margin-right: 10px;
    }

  }
</style>
